var _g, _ellipse, _path, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCatRun(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "92mm",
    height: "70mm",
    viewBox: "0 0 92 70",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 117.98 -83.435)",
    fillOpacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.326,
    y: 85.443,
    width: 70.774,
    height: 43.059,
    ry: 12.041,
    opacity: 0.86,
    strokeWidth: 0.19811
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.121,
    y: 92.293,
    width: 34.48,
    height: 33.273,
    ry: 12.041,
    opacity: 0.86,
    strokeWidth: 0.19811
  }), /*#__PURE__*/React.createElement("rect", {
    x: -362.44,
    y: 106.97,
    width: 193.81,
    height: 128.36,
    ry: 49.463,
    opacity: 0.86,
    strokeWidth: 0.26458
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -274.35,
    cy: 159.83,
    rx: 66.699,
    ry: 35.237,
    opacity: 0.86,
    strokeWidth: 0.26458
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.77,
    y: 49.234,
    width: 82.57,
    height: 54.802,
    ry: 2.9358,
    opacity: 0.86,
    strokeWidth: 0.19842
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "scale(-1,1)",
    cx: -59.424,
    cy: 22.695,
    rx: 31.47,
    ry: 22.072,
    fill: "#c8b7b7",
    fillRule: "evenodd",
    strokeWidth: 0.19811
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m86.261 16.865 3.4752-15.825-16.218 7.9127z",
    fillOpacity: 0,
    opacity: 0.86,
    strokeWidth: 0.19842
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 117.98 -83.435)",
    fill: "#c8b7b7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m28.633 99.88-2.7029-15.409 20.079 7.4963z",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.484 99.255 2.703-15.409-20.079 7.4963z",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.821,
    cy: 129.03,
    rx: 8.1089,
    ry: 17.075,
    fillRule: "evenodd",
    strokeWidth: 0.19811
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.177,
    cy: 136.11,
    rx: 19.693,
    ry: 14.16,
    fillRule: "evenodd",
    strokeWidth: 0.19811
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.455 115.29 6.1782 5.8304 9.6534 2.0823 1.5445 7.9127-18.921-7.0798z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.623 140.69c1.7809-1.5988 3.3378-3.439 5.1684-4.9806s4.026-2.8019 6.4157-2.9322c1.5245-0.0831 3.0531 0.303 4.4259 0.97109s2.598 1.6107 3.7047 2.6626c2.2133 2.1036 3.9713 4.645 6.1564 6.7778 0.61095 0.59632 1.2602 1.1638 2.0033 1.584 0.74316 0.42022 1.5899 0.68835 2.4428 0.65013 0.42644-0.0191 0.8508-0.11519 1.2375-0.29596 0.38671-0.18076 0.73502-0.44715 0.99871-0.78284 0.2637-0.33568 0.44106-0.74108 0.49344-1.1647 0.0524-0.42365-0.0225-0.8644-0.22529-1.24-0.22998-0.42597-0.61132-0.75275-1.0237-1.0063-0.41237-0.25356-0.86045-0.44245-1.2931-0.65952-2.3767-1.1923-4.2246-3.1937-6.1782-4.9975-2.6179-2.4171-5.5516-4.5614-8.8811-5.8304-1.4887-0.56739-3.0574-0.95657-4.6498-1.0049-1.5924-0.0484-3.2119 0.25482-4.6174 1.0049-1.4635 0.78108-2.6353 2.0043-3.7483 3.2344s-2.2116 2.5034-3.5883 3.4289c-1.0212 0.68648-2.1938 1.1813-3.0379 2.0765-0.42206 0.44763-0.75254 0.99765-0.86159 1.6031-0.05452 0.30275-0.05276 0.61668 0.01656 0.91638 0.06932 0.29971 0.20706 0.58473 0.4077 0.81791 0.28647 0.33292 0.69489 0.55088 1.1252 0.63887 0.4303 0.088 0.88102 0.0506 1.3027-0.072 0.84344-0.2454 1.5521-0.8129 2.2057-1.3997z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.522 151.42c-0.25251-1.9813-0.73436-4.1465-0.93384-6.0835-0.19949-1.937-0.09147-3.6839 0.75867-4.3703 0.54236-0.43789 1.3632-0.41742 2.2899-0.0846 0.92676 0.33283 1.9582 0.96888 3.0082 1.7396 2.0998 1.5413 4.2814 3.6176 6.3875 5.194 0.58886 0.44077 1.1756 0.84438 1.7118 1.0818 0.53624 0.23751 1.0229 0.30193 1.3312 0.065 0.1545-0.11786 0.26215-0.31162 0.30544-0.57908 0.04335-0.26736 0.02129-0.60954-0.07449-0.99977-0.09578-0.39021-0.26619-0.82849-0.49584-1.2554-0.2296-0.42691-0.51817-0.84112-0.81906-1.1609-0.34051-0.36318-0.68132-0.5938-0.9909-0.74552-0.30959-0.15173-0.59487-0.23183-0.89078-0.34311-1.6255-0.61113-3.5233-2.1378-5.3455-3.4465-2.4418-1.7535-4.8451-3.1661-6.8855-3.6295-0.91231-0.20718-1.7505-0.22122-2.3967 0.1039-0.64629 0.32505-1.0956 1.0006-1.1983 2.0634-0.10685 1.1068 0.16033 2.578 0.45438 4.0423 0.29406 1.4643 0.61921 2.9675 0.63124 4.1952 0.0089 0.91072-0.15402 1.6692 0.04675 2.7428 0.10039 0.53682 0.29673 1.1524 0.61167 1.7705 0.15749 0.30907 0.34341 0.61592 0.54722 0.89299 0.20374 0.27712 0.42534 0.52388 0.64078 0.70521 0.30757 0.25884 0.59461 0.37666 0.81345 0.36212 0.21893-0.0144 0.37167-0.15644 0.46286-0.37514 0.1824-0.43742 0.12245-1.1586 0.02977-1.8858z",
    strokeWidth: 0.7195
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.072 150.41c0.64225-1.8913 1.5459-3.917 2.1273-5.7754 0.58146-1.8584 0.82373-3.5918 0.12741-4.4339-0.44423-0.53718-1.2527-0.68069-2.2272-0.53921-0.97449 0.14148-2.112 0.55924-3.2946 1.1053-2.3648 1.092-4.9164 2.6919-7.2944 3.817-0.66488 0.31459-1.3203 0.5932-1.893 0.71904-0.57282 0.12589-1.0626 0.092-1.3175-0.20158-0.12792-0.14628-0.1948-0.3576-0.18393-0.62833 0.01078-0.27064 0.10058-0.60156 0.27222-0.96487 0.17162-0.3633 0.42595-0.75884 0.73605-1.1314 0.31006-0.3726 0.67538-0.721 1.034-0.97444 0.40605-0.28805 0.78598-0.44613 1.1196-0.53312 0.33362-0.087 0.62914-0.10864 0.94128-0.15872 1.7147-0.27497 3.8786-1.3929 5.925-2.3122 2.7422-1.2318 5.3788-2.1372 7.4706-2.1847 0.9353-0.0212 1.7595 0.13202 2.328 0.5794 0.56855 0.44732 0.87427 1.1988 0.76308 2.2608-0.11586 1.1059-0.67082 2.4944-1.2508 3.8707-0.57994 1.3763-1.1981 2.7846-1.4546 3.9853-0.19019 0.89068-0.1817 1.6665-0.59237 2.6785-0.20535 0.50605-0.52042 1.0702-0.95221 1.6131-0.21592 0.27149-0.45926 0.53514-0.71419 0.76604-0.25488 0.23097-0.5212 0.42862-0.76845 0.56339-0.35299 0.19236-0.65774 0.25062-0.8693 0.19276-0.21167-0.0577-0.33304-0.22736-0.37883-0.45985-0.09158-0.46499 0.11059-1.1598 0.34661-1.8539z",
    strokeWidth: 0.7195
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 117.98 -83.435)",
    fill: "none",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m37.9 114.04c-4.2473 0.27784-12.742 1.6658-12.742 1.6658z",
    strokeWidth: ".19811px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.661 117.83-11.947 4.4964z",
    strokeWidth: ".25864px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.613 112.07 14.268 3.1121z",
    strokeWidth: ".34322px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.22 114.88 10.42 5.4016z",
    strokeWidth: ".20984px"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 74.062 -61.74)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.54415,
    cy: 83.184,
    rx: 6.5614,
    ry: 5.8273,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.801,
    cy: 82.764,
    rx: 6.5614,
    ry: 5.8273,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#a05a2c",
    strokeWidth: 0.26458
  }, /*#__PURE__*/React.createElement("rect", {
    x: 433.79,
    y: 167.07,
    width: 22.967,
    height: 61.493,
    rx: 11.484,
    ry: 5.2572
  }))), /*#__PURE__*/React.createElement("ellipse", {
    className: "lefteyeruncat",
    transform: "scale(-1,1)",
    cx: -73.432,
    cy: 21.121,
    rx: 3.6103,
    ry: 2.8865,
    strokeWidth: 0.21247
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "righteyeruncat",
    transform: "scale(-1,1)",
    cx: -47.178,
    cy: 20.731,
    rx: 3.6103,
    ry: 2.8865,
    strokeWidth: 0.21247
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatRun);
export default __webpack_public_path__ + "static/media/cat_run.ee7b9be4e8d4b201b86bd046f9d63088.svg";
export { ForwardRef as ReactComponent };